/**
 * URL for a `crossOrigin="anonymous"` load of a remote asset.
 *
 * The asset host only answers with `Access-Control-Allow-Origin` when the request carries an
 * `Origin` header and sends no `Vary`, so a plain load (a preview `<video>`, a CSS
 * background-image) and a CORS load of the same URL would share one cache entry and the CORS
 * load would then fail with MissingAllowOriginHeader. Appending `cors=1` gives CORS loads their
 * own cache key. blob:, data:, relative and same-origin URLs are returned unchanged.
 */
export function corsSource(url: string) {
  if (!/^https?:\/\//i.test(url)) return url;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  if (parsed.origin === window.location.origin) return url;
  if (parsed.searchParams.get('cors') === '1') return url;
  parsed.searchParams.append('cors', '1');
  return parsed.href;
}
